import { render, staticRenderFns } from "./SingleSelect.vue?vue&type=template&id=5f0b44aa"
import script from "./SingleSelect.vue?vue&type=script&lang=js"
export * from "./SingleSelect.vue?vue&type=script&lang=js"
import style0 from "./SingleSelect.vue?vue&type=style&index=0&id=5f0b44aa&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports